import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
	const { pathname } = useLocation();

	// Before paint, not after: a useEffect here let the new route render at the
	// previous scroll position for a frame, which shows as a band of the old page
	// under the fixed header.
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
}
